import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

/**
 * Botão pequeno que copia um texto para o clipboard com feedback visual.
 * Usa Clipboard API com fallback para textarea+execCommand em browsers antigos.
 */
export function CopyButton({
  value,
  label,
  size = 'sm',
  className,
}: {
  value?: string | null
  label?: string
  size?: 'xs' | 'sm'
  className?: string
}) {
  const [copied, setCopied] = useState(false)
  if (!value) return null
  const dim = size === 'xs' ? 'h-3 w-3' : 'h-3.5 w-3.5'
  const handle = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      const ta = document.createElement('textarea')
      ta.value = value
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      } catch {
        /* sem clipboard disponível */
      }
      document.body.removeChild(ta)
    }
  }
  return (
    <button
      type="button"
      onClick={handle}
      className={`inline-flex items-center justify-center rounded-md p-1 hover:bg-accent transition-colors ${copied ? 'text-green-600' : 'text-muted-foreground hover:text-foreground'} ${className || ''}`}
      title={copied ? 'Copiado!' : label ? `Copiar ${label}` : 'Copiar'}
    >
      {copied ? <Check className={dim} /> : <Copy className={dim} />}
    </button>
  )
}
